import type { ButtonGroupStyleTypes } from '@material-tailwind/react';

const styles: ButtonGroupStyleTypes = {
  defaultProps: {
    variant: 'filled',
    size: 'md',
    color: 'blue',
    ripple: false,
  },
  valid: {
    variants: ['filled'],
    sizes: ['md'],
    colors: ['blue'],
  },
  styles: {
    base: {
      initial: {
        active: '',
      },
    },
  },
};

export default styles;
